// removed by extract-text-webpack-plugin
module.exports = {"container":"_3qs4IqxHpqk0PW9qMRZapP","containerWithZIndex":"_3ZGebDDQRctpXBrrEUFOV8","suggestionsContainer":"_3xq2OHMEIGNJl6HhFpnXbs","suggestionsList":"_2M5sNOaZwRrsi_j3WQDE3s","suggestion":"_2pX_6uy9DIoI86JA94Sh2r","suggestionHighlighted":"_2UIAq1nrd_903gk_uT_j7B"};


//////////////////
// WEBPACK FOOTER
// ./src/theme/components/autosuggest.scss
// module id = 1388
// module chunks = 1